import { SxProps, Theme } from "@mui/material";

export const landingPageContainer: SxProps<Theme> = {
  display: "flex",
  width: "100%",
  maxWidth: "720px",
  flexDirection: "column",
  alignItems: "center",
  gap: "32px",
  paddingLeft: "24px",
  paddingRight: "24px",
};

export const mainSection: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "48px",
  flex: "1 0 0",
  width: "100%",
  maxWidth: "720px",
};

export const helloText: SxProps<Theme> = {
  color: "#000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "33.3px",
  fontWeight: 700,
  lineHeight: "normal",
  fontStyle: "normal",
};

export const subTextSection: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
};

export const pinPromptText: SxProps<Theme> = {
  color: "#000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "18px",
  fontWeight: 400,
  lineHeight: "normal",
  fontStyle: "normal",
  width: "100%",
  maxWidth: "573px",
  height: "21px",
};

export const pinInputBox: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
  maxWidth: "309px",
  gap: "10px",
};

export const pinInputField = (pinLength: number): SxProps<Theme> => ({
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "20px",
  height: "31px",
  alignSelf: "stretch",
  fontWeight: 700,
  lineHeight: "normal",
  fontStyle: "normal",
  color: pinLength > 0 ? "#595959" : "#ECECEC",
});

export const pinTextFieldWrapper: SxProps<Theme> = {
  width: "100%",
  maxWidth: "309px",
  "& .MuiInput-underline:before": {
    borderBottomColor: "#ECECEC",
    borderBottomWidth: "0.5px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#595959",
    borderBottomWidth: "0.5px",
  },
};

export const helperTextBox: SxProps<Theme> = {
  width: "100%",
  maxWidth: "696px",
};

export const helperText: SxProps<Theme> = {
  color: "#595959",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "20px",
  fontStyle: "italic",
  fontWeight: 400,
  lineHeight: "normal",
};

export const InvalidText: SxProps<Theme> = {
  color: "#EB0000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "100%",
};

export const pinErrorText: SxProps<Theme> = {
  color: "#EB0000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "normal",
};
